import { createSlice } from "@reduxjs/toolkit";

const initialGalleryState = {
  currentIndex: 0,
  maxIndex: 0,
};

const gallerySlice = createSlice({
  name: "gallery",
  initialState: initialGalleryState,
  reducers: {
    nextIndex(state) {
      if (state.currentIndex === state.maxIndex) return;
      state.currentIndex = ++state.currentIndex;
    },
    prevIndex(state) {
      if (state.currentIndex === 0) return;
      state.currentIndex = --state.currentIndex;
    },
    setCurrentIndex(state, action) {
      state.currentIndex = action.payload;
    },
    setMaxIndex(state, action) {
      state.maxIndex = action.payload;
    },
  },
});

export const galleryActions = gallerySlice.actions;

export default gallerySlice.reducer;
